export enum PrivilegesEnum {
  EXTERNAL_SOURCES = 'external-sources',
  AI_GUIDELINES = 'ai-guidelines',
  KNOWLEDGE_BASE = 'knowledgebase',
  DASHBOARD = 'dashboard',
  INBOX = 'inbox',
  INTEGRATIONS = 'integrations',
  SETTINGS = 'settings',
  SUBSCRIPTION = 'subscription',
}
